import { Component, OnInit, ViewChild, Input, Output, EventEmitter, OnChanges, SimpleChanges, OnDestroy } from '@angular/core';
import { MatPaginator, MatPaginatorIntl } from '@angular/material/paginator';
import { gridFilterSettings, GridParameters } from './gridParameters';
import { GridTableParametersService } from './gridTableParameters.service';
import { SharingDataService } from 'src/app/Services/sharing-data.service';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { TranslateResourceDefinitionPipe } from 'src/app/shared/pipes/translateResourceDefinition.pipe';
import { StatePersistService } from 'src/app/Services/statePersist.service';
import { AuthentService } from 'src/app/Services/authent.service';
import { Router } from '@angular/router';

let paginatorIntll = new MatPaginatorIntl();

@Component({
  selector: 'app-grid-template',
  templateUrl: './gridTemplate.component.html',
  styleUrls: ['./gridTemplate.component.css'],
  providers: [
    { provide: MatPaginatorIntl, useValue: paginatorIntll }
  ]
})
export class GridTemplateComponent implements OnInit, OnChanges {
  @Input() methods: {
    refresh?: () => void;
  } = {};
  @Input() title = "";
  @Input() enableHideEmpty = false;
  @Input() columns;
  @Input() urlString;
  @Input() defaultFilter;
  @Input() defaultOrderby = [[], []];
  @Input() gridData;
  @Input() exportToExcelButton: boolean;
  @Input() exportToExcelName: string;
  @Input() clearFiltersButton: boolean;
  @Input() groupName: string;
  @Input() selectedSingleRow;
  @Input() selectedMultiRow;
  @Input() selectedKey : string;
  @Output() action = new EventEmitter();

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  resourceDefinition;
  Picklist;
  Language;
  gridParameters = new GridParameters();
  paginatorIntl = paginatorIntll;
  currentUrlString;
  currentColumns;
  routerString;

  constructor(
    public grid: GridTableParametersService,
    private shareData: SharingDataService,
    public translateResourceDefinition: TranslateResourceDefinitionPipe,
    private statePersistService: StatePersistService,
    private authService: AuthentService,
    private router: Router,
  ) { }



  ngOnInit(): void {
    // Set public methods definition
    this.methods.refresh = () => {
      this.onChanges(null);
    }
    
    this.routerString = "";
    if(this.router.url.indexOf("?")>0){
      this.routerString = this.router.url.substr(0, this.router.url.indexOf("?"));
    } else {
      this.routerString = this.router.url;
    }

    this.shareData.currentResourceDefinition.subscribe(data => {
      this.resourceDefinition = data;
      this.grid.getPaginatorIntl(this.paginatorIntl);
    });
    this.shareData.currentPicklist.subscribe(data => this.Picklist = data);
    this.shareData.currentLanguage.subscribe(data => this.Language = data);
    this.getFormat();

    this.gridParameters.dataSource = new MatTableDataSource(this.gridData);
  }

  onChanges(changes: SimpleChanges){
    if (changes?.columns) {
      this.currentColumns = changes.columns.currentValue;
    }
    if (changes?.urlString) {
      this.currentUrlString = changes.urlString.currentValue;
    }
    if (this.currentColumns != undefined && this.currentUrlString != undefined) {
      this.getFormat();
      this.gridParameters.selectedKey = this.selectedKey;
      var settings = this.statePersistService.get(this.urlString);
      this.gridParameters.displayedColumns = [];
      if(settings != null){
        this.updateColumns(settings);
        if(settings?.orderColumns != []){
          this.defaultOrderby[0] = settings.orderColumns;
          this.defaultOrderby[1] = settings.orderColumnsArrow;
        }
      }
      this.gridParameters.exportToExcelName = this.exportToExcelName;
      this.gridParameters.orderColumns = this.defaultOrderby[0];
      this.gridParameters.orderColumnsArrow = this.defaultOrderby[1];
      this.columns.forEach(element => {
        if (element.visible === true) {
          this.gridParameters.displayedColumns.push(element.name);
        }
        for (let i = 0; i < this.defaultOrderby[0].length; i++) {
          if (this.defaultOrderby[0][i] == element.name) {
            element.orderByArrow = this.defaultOrderby[1][i];
          }
        }
      });
      this.gridParameters.table = changes?.urlString?.currentValue ? changes?.urlString?.currentValue : this.urlString;
      if (this.defaultFilter != undefined && this.defaultFilter != ``) {
        this.gridParameters.defaultFilter = `(${this.defaultFilter})`;
      }
      this.gridParameters.parameterUrlOld = "";
      if(this.selectedMultiRow != undefined){
        this.gridParameters.selectedMultiRows = this.selectedMultiRow;
      }
      if(this.selectedSingleRow != undefined){
        this.gridParameters.selectedSingleRows = this.selectedSingleRow;
      }
      this.getData();
      this.gridParameters.pageSizeOptions = [5, 10, 20];
      if(settings?.pageInfo != null){
        this.gridParameters.pageSize = settings.pageInfo.pageSize;
        this.paginator.pageIndex = settings.pageInfo.pageIndex;
        this.gridParameters.pageInfo = settings.pageInfo;
      } else {
        this.gridParameters.pageSize = 5;
        this.gridParameters.pageInfo.pageSize = this.gridParameters.pageSize;
      }
    } else {
      if (this.gridData) {
        this.gridParameters.displayedColumns = [];
        this.columns.forEach(element => {
          if (element.visible === true) {
            this.gridParameters.displayedColumns.push(element.name);
          }
        });
        this.gridParameters.dataSource = new MatTableDataSource(this.gridData);
        this.gridParameters.dataLength = this.gridData.length;
        this.gridParameters.dataSource.data.length = this.gridParameters.dataLength;
        this.gridParameters.pageSizeOptions = [5, 10, 20];
        this.gridParameters.dataSource.paginator = this.paginator;
        this.gridParameters.showLoading = false;
      }
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    this.onChanges(changes)
  }

  getData() {
    this.grid.getData(false, true, this.gridParameters, this.columns, this.paginator);
  }

  getFormat() {
    if(this.resourceDefinition != undefined && this.columns != undefined){
      this.columns.forEach(columnElement => {
        this.resourceDefinition.forEach(tableElement => {
          if (columnElement.name == tableElement.KEY_NAME) {
            columnElement.format = tableElement.FORMAT;
          }
        });
      });
    }
  }

  updateColumns(settings) {
    settings.array.forEach(e => {
      this.columns.forEach(element => {
        if (element.name == e.name) {
          element.dateFromToFilter = e.dateFromToFilter;
          element.dateMonthFilter = e.dateMonthFilter;
          element.fromToFilterValues = e.fromToFilterValues;
          element.picklistSelectedItems = e.picklistSelectedItems;
          element.search = e.search;
        }
      });
    });
  }

  columAction(action: string, element, column) {
    if (column.enableSelect == true) {
      this.grid.addSelectSingle(element, this.gridParameters);
      this.grid.addSelectMulti(element, this.gridParameters);
    }
    var object = {
      action: action,
      element: element,
      column: column,
      selectedSingleRows: element,
      selectedMultiRows: this.gridParameters.selectedMultiRows,
    }
    this.action.emit(object);
  }
}